export function isCcpaEligible(uspString = '') {
  if (uspString && uspString.length < 4) return false;
  return uspString[1] !== 'N' && uspString[2] !== 'Y';
}
